<template>
  <div class="def-footer" v-if="!isPhone">
    <div :class="{'def-bg': !noBg}">
      <div class="ft-top">
        <div class="ftt-1">
          <p class="ft1-icon">法天眼</p>
          <p class="ft1-deatil">劳动用工法律体检系统：<br/>
            全程、系统、智能生成劳动用工法律风险评估报告、劳动用工法律风险管控手册、<br/>
            劳动用工法律风险整改措施、并自动匹配落地标准合同、协议、表单、表格等法律文书及视频解读<br/>
          </p>
        </div>
        <div class="ftt-2">
          <dl>
            <dt class="line"><div style="cursor: pointer;">产品矩阵</div></dt>
            <dd><div @click="openNewLink('http://www.lvyingjiaoyu.com/')" style="cursor: pointer;">合规管理</div></dd>
            <dd><div @click="openNewLink('http://www.fajiankeji.com/')" style="cursor: pointer;">用工体检</div></dd>
            <dd><div @click="openNewLink('https://cgjt.ai.lvpin100.com/pc')" style="cursor: pointer;">劳动法智能咨询</div></dd>
            <dd><div @click="openNewLink('https://apppiq67wgz6785.pc.xiaoe-tech.com')" style="cursor: pointer;">十大用工</div></dd>
            <dd><div @click="openNewLink('http://www.lvyingjiaoyu.com/moreGoods?classifyId=5')" style="cursor: pointer;">法天眼商城</div></dd>
          </dl>
          <dl>
            <dt class="line"><div @click="navgtTo('/Express',{curTabIndex: '0'})" style="cursor: pointer;">风险快报</div></dt>
            <dd><div @click="navgtTo('/Express',{curTabIndex: '1'})" style="cursor: pointer;">行业动态</div></dd>
            <dd><div @click="navgtTo('/Express',{curTabIndex: '2'})" style="cursor: pointer;">新法速递</div></dd>
            <dd><div @click="navgtTo('/Express',{curTabIndex: '3'})" style="cursor: pointer;">新闻资讯</div></dd>
            <dd><div @click="navgtTo('/Express',{curTabIndex: '4'})" style="cursor: pointer;">业绩报道</div></dd>
          </dl>
          <dl>
            <dt class="line"><div style="cursor: pointer" @click="navgtTo('/aboutUs')">关于我们</div></dt>
            <dd><div style="cursor: pointer" @click="navgtTo('/aboutUs#bqsm')">版权声明</div></dd>
            <dd><div style="cursor: pointer" @click="navgtTo('/aboutUs#ysbh')">隐私保护</div></dd>
            <dd><div style="cursor: pointer" @click="navgtTo('/aboutUs#lxwm')">联系我们</div></dd>
          </dl>
          <dl>
            <dt class="line"><div @click="navgtTo('/lawyer')" style="cursor: pointer;">合作伙伴</div></dt>
            <dd><div style="cursor: pointer" @click="goToMerchant">律师/机构注册</div></dd>
          </dl>
        </div>
<!--        <div class="ftt-3">
          &lt;!&ndash;<div class="ft3-warp">
            <img width="80" height="80" src="../assets/foot-code.png"/>
            <p class="ft3-txt">微信公众号</p>
          </div>&ndash;&gt;
          <div class="ft3-warp">
            <img style="width: 80px;height: 80px;" src="../assets/andorid.png"/>
            <p class="ft3-txt">安卓APP</p>
          </div>
          <div class="ft3-warp">
            <img style="width: 80px;height: 80px;" src="../assets/iosAppDownload.png"/>
            <p class="ft3-txt">苹果APP</p>
          </div>
        </div>-->
      </div>
      <div class="ft-btm">
        <p class="complay-info">联系地址：北京市北京经济技术开发区荣华中路22号院1号楼10层1002-A43&nbsp; &nbsp; &nbsp;官方邮箱：529069815@qq.com &nbsp;
          &nbsp; 联系电话：13321136230 &nbsp; &nbsp; 服务时间：周一至周日 09:00 – 18:00</p>
        <p class="complay-info" style="margin-top: 18px;">Copyright © 2019 法天眼 版权声明</p>
        <p><a href="http://beian.miit.gov.cn">京ICP备19053828号-1</a></p>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="ft-btmMoble">
      <p>北京市北京经济技术开发区荣华中路22号院1号楼10层1002-A43</p>
      <p>官方邮箱：529069815@qq.com</p>
      <p>联系电话：13321136230</p>
      <p>服务时间：周一至周日 09:00 – 18:00</p>
      <p>Copyright © 2019 法天眼 版权声明.</p>
      <p><a href="http://beian.miit.gov.cn">京ICP备19053828号-1</a></p>
    </div>
  </div>
</template>

<script>
  import {isPhone} from '@/components/utils/isPhone'
  export default {
    name: "Footer",
    data() {
      return {
        isPhone: false
      }
    },
    props: {
      noBg: Boolean,
    },
    created() {
      this.isPhone = isPhone();
    },
    methods: {
      navgtTo: function (path,query) {
        this.$router.push({path: path,query:query });
      },
      goToMerchant: function() {
        this.$router.push('/userMerchantRegister')
        /*if (localStorage.getItem('userToken') && localStorage.getItem("userToken") !== 'null'
          && localStorage.getItem("userToken") !== 'undefined') {
          this.$router.push('/userInfo/userMerchant')
        }else{
          this.$router.push('/userMerchantRegister')
        }*/
      },
      openNewLink: function (url) {
        window.open(url);
      }
    }
  }
</script>

<style scoped>
  .def-bg {
    background-color: #00bca1;
  }

  /*footer start*/
  .def-footer {
    padding-top: 60px;
    overflow: hidden;
    min-width: 1100px;  /* 我手动加的 */
  }

  .def-footer .ft-top {
    background: rgba(0, 0, 0, 0.3);
    padding-top: 38px;
    height: 206px;
    color: #fff;
    display: flex;
    justify-content: center;
    font-family: SourceHanSansSC-regular;
  }

  /*top left*/
  .def-footer .ft-top .ftt-1 {
    width: 329px;
  }

  .def-footer .ft-top .ftt-1 .ft1-icon {
    height: 32px;
    line-height: 32px;
    font-size: 28px;
  }

  .def-footer .ft-top .ftt-1 .ft1-deatil {
    margin-top: 15px;
    font-size: 14px;
    line-height: 30px;
  }

  /*top center*/
  .def-footer .ft-top .ftt-2 {
    width: 500px;
    padding-left: 28px;
    display: flex;
  }

  .def-footer .ft-top .ftt-2 dl {
    padding-left: 80px;
    font-family: Roboto;
  }

  .def-footer .ft-top .ftt-2 dl dt {
    padding-bottom: 15px;
    position: relative;
    height: 23px;
    font-weight: 600;
    line-height: 23px;
    font-size: 16px;
    /* 我手动加的 */
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  .def-footer .ft-top .ftt-2 dl dt.line::after {
    content: '';
    position: absolute;
    left: 0;
    top: 28px;
    width: 20px;
    height: 2px;
    background: #10C0A7;
  }

  .ft-btmMoble{
    background-color: #10C0A7;
    color: white;
  }

  .def-footer .ft-top .ftt-2 dl dd {
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    /* 我手动加的 */
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  /*top right*/
  .def-footer .ft-top .ftt-3 {
    width: 310px;
    display: flex;
  }

  .def-footer .ft-top .ftt-3 .ft3-warp {
    padding-top: 30px;
    padding-left: 76px;
  }

  .def-footer .ft-top .ftt-3 .ft3-txt {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    margin-top: 16px;
    text-align: center;
  }

  /*bottom*/
  .def-footer .ft-btm {
    padding: 34px 76px 22px;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
  }

  .def-footer .ft-btm .complay-info {
    height: 23px;
    line-height: 23px;
    color: #EEF1F4;
    font-size: 14px;
    font-family: Roboto;
  }

  /*end footer*/

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue